import moment from 'moment';

import {
    ANIMATE_SERVICE_CALL_LIST,
    FETCH_APPOINTMENT_STATUSES,
    FETCH_CALL_PRIORITIES,
    FETCH_CALL_STATUSES,
    FETCH_COMPANY_ALIAS,
    FETCH_ISSUE_TYPES,
    FETCH_SERVICE_ITEM_LIST,
    FETCH_SM_AREAS,
    FETCH_SM_CLIENTS,
    FETCH_SM_CONTACTS,
    FETCH_SM_EQUIPMENT_AND_SYSTEMS,
    FETCH_SM_RULES,
    FETCH_SM_SITES,
    FETCH_SM_TECHNICIAN_LIST,
    RESET_FILTERS,
    RESET_LISTS,
    SET_ACTIVE_APPOINTMENT,
    SET_ACTIVE_ITEM,
    SET_ARE_FILTERS_APPLIED,
    SET_CALL_ISSUES,
    SET_CALL_SOURCES_FILTER,
    SET_CALL_STATUS,
    SET_CALL_STATUSES_FILTER,
    SET_CLIENTS_FILTER,
    SET_DRAWER_OPEN,
    SET_END_TIMESTAMP,
    SET_EQUIPMENT_FILTER,
    SET_ISSUE_TYPES_FILTER,
    SET_ITEM_IS_ACTIVE,
    SET_PRIORITY,
    SET_PRIORITIES_FILTER,
    SET_SEARCH_VALUE,
    SET_SITES_FILTER,
    SET_SM_AREA,
    SET_SM_CLIENT,
    SET_SM_CONTACT,
    SET_SM_EQUIPMENT_OR_SYSTEM,
    SET_SM_SITE,
    SET_SORTBY_FILTER,
    SET_START_TIMESTAMP,
    SET_SYSTEMS_FILTER
} from '../actions/actionTypes';

const initialState = {
    activeItem:              {},
    activeAppointment:       {},
    alias:                   {name: '', email: '', enabled: false, id: ''},
    appointmentStatuses:     [],
    areasList:               [],
    areFiltersApplied:       false,
    callIssues:              [],
    callPriorities:          [],
    callSourcesFilter:       {callSources: []},
    callStatus:              '',
    callStatuses:            [],
    callStatusesFilter:      {callStatuses: []},
    clientsFilter:           {clients: [], businessTypes: []},
    clientsList:             [],
    contactsList:            [],
    endTimeStamp:            moment().local().endOf('day'),
    equipmentFilter:         {equipment: []},
    equipmentAndSystemList:  [],
    animationTarget:         null,
    isDrawerOpen:            false,
    isItemActive:            false,
    issueTypes:              [],
    issueTypesFilter:        {issueTypes: []},
    priority:                '',
    prioritiesFilter:        {priorities: []},
    rulesList:               [],
    searchValue:             '',
    serviceItemList:         {meta: {}, serviceItemList: []},
    sitesFilter:             {sites: [], buildingTypes: []},
    sitesList:               [],
    sortByFilter:            'lastModifiedTimestamp',
    startTimeStamp:          moment().subtract(7,'d').local().startOf('day'),
    systemsFilter:           {systems: []},
    targetArea:              {},
    targetClient:            {},
    targetContact:           {},
    targetEquipmentOrSystem: {},
    targetSite:              {},
    technicianList:          []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ANIMATE_SERVICE_CALL_LIST:
            return {
                ...state,
                animationTarget: action.payload
            };
        case FETCH_APPOINTMENT_STATUSES:
            return {
                ...state,
                appointmentStatuses: [...action.payload]
            };
        case FETCH_CALL_PRIORITIES:
            return {
                ...state,
                callPriorities: [...action.payload]
            };
        case FETCH_CALL_STATUSES:
            return {
                ...state,
                callStatuses: [...action.payload]
            };
        case FETCH_COMPANY_ALIAS:
            return {
                ...state,
                alias: {...action.payload}
            };
        case FETCH_ISSUE_TYPES:
            return {
                ...state,
                issueTypes: [...action.payload]
            };
        case FETCH_SERVICE_ITEM_LIST:
            return {
                ...state,
                serviceItemList: action.payload
            };
        case FETCH_SM_AREAS:
            return {
                ...state,
                areasList: [...action.payload]
            };
        case FETCH_SM_CLIENTS:
            return {
                ...state,
                clientsList: [...action.payload]
            };
        case FETCH_SM_CONTACTS:
            return {
                ...state,
                contactsList: [...action.payload]
            };
        case FETCH_SM_EQUIPMENT_AND_SYSTEMS:
            return {
                ...state,
                equipmentAndSystemList: [...action.payload]
            };
        case FETCH_SM_RULES:
            return {
                ...state,
                rulesList: [...action.payload]
            };
        case FETCH_SM_SITES:
            return {
                ...state,
                sitesList: [...action.payload]
            };
        case FETCH_SM_TECHNICIAN_LIST:
            return {
                ...state,
                technicianList: [...action.payload]
            };
        case RESET_FILTERS:
            return {
                ...state,
                areFiltersApplied:  false,
                callSourcesFilter:  {callSources: []},
                callStatusesFilter: {callStatuses: []},
                clientsFilter:      {clients: [], businessTypes: []},
                equipmentFilter:    {equipment: []},
                issueTypesFilter:   {issueTypes: []},
                prioritiesFilter:   {priorities: []},
                sitesFilter:        {sites: [], buildingTypes: []},
                systemsFilter:      {systems: []}
            };
        case RESET_LISTS:
            return {
                ...state,
                areasList:              [],
                equipmentAndSystemList: [],
            };
        case SET_ACTIVE_APPOINTMENT:
            return {
                ...state,
                activeAppointment: {...action.payload}
            };
        case SET_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: {...action.payload}
            };
        case SET_ARE_FILTERS_APPLIED:
            return {
                ...state,
                areFiltersApplied: action.payload
            };
        case SET_CALL_ISSUES:
            return {
                ...state,
                callIssues: [...action.payload]
            };
        case SET_CALL_STATUS:
            return {
                ...state,
                callStatus: action.payload
            };
        case SET_CALL_SOURCES_FILTER:
            return {
                ...state,
                callSourcesFilter: {...action.payload}
            };
        case SET_CALL_STATUSES_FILTER:
            return {
                ...state,
                callStatusesFilter: {...action.payload}
            };
        case SET_CLIENTS_FILTER:
            return {
                ...state,
                clientsFilter: {...action.payload}
            };
        case SET_END_TIMESTAMP:
            return {
                ...state,
                endTimeStamp: action.payload
            };
        case SET_EQUIPMENT_FILTER:
            return {
                ...state,
                equipmentFilter: {...action.payload}
            };
        case SET_DRAWER_OPEN:
            return {
                ...state,
                isDrawerOpen: action.payload
            };
        case SET_ISSUE_TYPES_FILTER:
            return {
                ...state,
                issueTypesFilter: {...action.payload}
            };
        case SET_ITEM_IS_ACTIVE:
            return {
                ...state,
                isItemActive: action.payload
            };
        case SET_PRIORITY:
            return {
                ...state,
                priority: action.payload
            };
        case SET_PRIORITIES_FILTER:
            return {
                ...state,
                prioritiesFilter: {...action.payload}
            };
        case SET_SEARCH_VALUE:
            return {
                ...state,
                searchValue: action.payload
            };
        case SET_SITES_FILTER:
            return {
                ...state,
                sitesFilter: {...action.payload}
            };
        case SET_SM_AREA:
            return {
                ...state,
                targetArea: {...action.payload}
            };
        case SET_SM_CLIENT:
            return {
                ...state,
                targetClient: {...action.payload}
            };
        case SET_SM_CONTACT:
            return {
                ...state,
                targetContact: {...action.payload}
            };
        case SET_SM_EQUIPMENT_OR_SYSTEM:
            return {
                ...state,
                targetEquipmentOrSystem: {...action.payload}
            };
        case SET_SM_SITE:
            return {
                ...state,
                targetSite: {...action.payload}
            };
        case SET_SORTBY_FILTER:
            return {
                ...state,
                sortByFilter: action.payload
            };
        case SET_START_TIMESTAMP:
            return {
                ...state,
                startTimeStamp: action.payload
            };
        case SET_SYSTEMS_FILTER:
            return {
                ...state,
                systemsFilter: {...action.payload}
            };
        default:
            return state;
    }
};
